/**
 * Backoff for a socket that keeps failing to authenticate: rejected token, auth timeout,
 * or the server closing it before answering. Unlike a plain transport drop, retrying
 * fast can't fix these, and every retry is a fresh connection on the server. A tab left
 * open on a bad token would otherwise hit it every ~1.5s indefinitely.
 */
export const AUTH_RETRY_BASE_DELAY_MS = 1_000
export const AUTH_RETRY_MAX_DELAY_MS = 5 * 60_000
/** ±20%, so many tabs failing together don't retry in lockstep. */
export const AUTH_RETRY_JITTER_RATIO = 0.2

/** Delay before the next attempt after `streak` consecutive failures (streak >= 1). */
export function authRetryDelayMs(streak: number, random: () => number = Math.random): number {
  const exponent = Math.max(0, streak - 1)
  const delay = Math.min(AUTH_RETRY_BASE_DELAY_MS * 2 ** exponent, AUTH_RETRY_MAX_DELAY_MS)
  const jitter = 1 + (random() * 2 - 1) * AUTH_RETRY_JITTER_RATIO
  return Math.round(delay * jitter)
}
